import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BasetaoSpreadsheetGuide from "../pages/basetao-spreadsheet-guide/page";
import BasetaoReview from "../pages/basetao-review/page";
import BasetaoShippingCost from "../pages/basetao-shipping-cost/page";
import BasetaoWarehouse from "../pages/basetao-warehouse/page";
import BasetaoCoupon from "../pages/basetao-coupon/page";
import BasetaoShoesSpreadsheet from "../pages/basetao-shoes-spreadsheet/page";
import BasetaoFashionSpreadsheet from "../pages/basetao-fashion-spreadsheet/page";
import BasetaoBeginnerGuide from "../pages/basetao-beginner-guide/page";
import BasetaoVsAlternatives from "../pages/basetao-vs-alternatives/page";
import BasetaoAdvancedStrategies from "../pages/basetao-advanced-strategies/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/basetao-spreadsheet-guide",
    element: <BasetaoSpreadsheetGuide />,
  },
  {
    path: "/basetao-review",
    element: <BasetaoReview />,
  },
  {
    path: "/basetao-shipping-cost",
    element: <BasetaoShippingCost />,
  },
  {
    path: "/basetao-warehouse",
    element: <BasetaoWarehouse />,
  },
  {
    path: "/basetao-coupon",
    element: <BasetaoCoupon />,
  },
  {
    path: "/basetao-shoes-spreadsheet",
    element: <BasetaoShoesSpreadsheet />,
  },
  {
    path: "/basetao-fashion-spreadsheet",
    element: <BasetaoFashionSpreadsheet />,
  },
  {
    path: "/basetao-beginner-guide",
    element: <BasetaoBeginnerGuide />,
  },
  {
    path: "/basetao-vs-alternatives",
    element: <BasetaoVsAlternatives />,
  },
  {
    path: "/basetao-advanced-strategies",
    element: <BasetaoAdvancedStrategies />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;